module.exports = __webpack_public_path__ + "img/voucher2.4d4f3e81.png";